import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Portfolio from "@/components/Portfolio";
import Services from "@/components/Services";
import About from "@/components/About";
import ContactBooking from "@/components/ContactBooking";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-sand text-ocean">
      <Navbar />
      <Hero />
      <Portfolio />
      <Services />
      <About />
      <ContactBooking />
      <Footer />
    </main>
  );
}
